import { css } from 'styled-system/css';
import { CommentsPanel } from './CommentsPanel';
import { MockFrame } from './MockFrame';
import { SheetGrid } from './SheetGrid';
import { SheetStatus } from './SheetStatus';

export function SheetsMockup() {
  return (
    <MockFrame rounded share light dots={false}>
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
        })}
      >
        <div
          className={css({
            display: 'flex',
            flex: 1,
            minHeight: 0,
          })}
        >
          <div
            className={css({
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
            })}
          >
            <SheetGrid selected={-1} commentedRow={0} />
          </div>
          <CommentsPanel />
        </div>
        <SheetStatus />
      </div>
    </MockFrame>
  );
}
